import { Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { IndicatorType } from '@melodic-ui/types';

@Component({
	selector: 'lb-grade-tag',
	template: `
		@if (compact()) {
			<div class="grade-tag grade-tag--compact" [ngStyle]="inlineStyle()">
				{{ grade() }}
			</div>
			@if (categoryName()) {
				<span class="grade-tag__label">{{ categoryName() }}</span>
			}
		} @else {
			<div class="grade-tag" [ngStyle]="inlineStyle()">
				{{ grade() }}
			</div>
		}
	`,
	styleUrl: './grade-tag.component.scss',
	standalone: true,
	imports: [NgStyle],
	host: {
		'[class]': 'hostClass()'
	}
})
export class GradeTagComponent {
	grade = input.required<string>();
	/** Use for design-system palette colours (applies CSS class). */
	type = input<IndicatorType>('default');
	/** Use for raw hex colours returned by the API (applies inline style). When set, overrides `type`. */
	hexColor = input<string | null>(null);
	/** Renders a small square badge (28×28) instead of the full pill. */
	compact = input<boolean>(false);
	/** Optional label displayed beside the badge in compact mode. */
	categoryName = input<string | null>(null);

	hostClass = computed(() => {
		const base = this.hexColor() ? '' : this.type();
		return this.compact() ? `${base} grade-tag--compact-host` : base;
	});
	inlineStyle = computed(() => {
		const hex = this.hexColor();
		return hex ? { color: hex, borderColor: hex } : {};
	});
}
